import { createFeatureSelector } from "@ngrx/store";
import * as fromReducer from "./resources.reducers";
import { ResourcesState, resourcesFeatureKey } from "./resources.reducers";

const selectFeature = createFeatureSelector<ResourcesState>(
    resourcesFeatureKey,
);

export const {
    selectAll: selectAllResources,
    selectEntities: selectResourceEntities,
} = fromReducer.adapter.getSelectors(selectFeature as any);

export const selectResourceById = (id: string) => (state: any) => {
    return selectResourceEntities(state)[id];
}

export const selectIsLoading = (state: any) => {
    return state[resourcesFeatureKey].isLoading;
}
